<template>
  <div class="fabric-content-box">
    <div class="fabric-content-wrap">
      <div class="info-wrap">
        <div class="flex justify-around">
          <div class="left-popup">
            <div
              v-if="detail.image_list.length > 0 || detail.video"
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide v-if="detail.video">
                  <video
                    v-if="detail.video"
                    :src="detail.video"
                    muted
                    autoplay
                    controls
                    id="video-material"
                  >
                    您的浏览器不支持视频播放。
                  </video>
                </swiper-slide>
                <swiper-slide
                  v-for="(item, index) in detail.image_list"
                  :key="`sl` + index"
                >
                  <!-- <img v-viewer :src="item.url" class="img" :alt="detail.fabric_name || detail.name || ''" /> -->
                   <img :src="detail.image_list[curr_slider_index].url" v-viewer alt="" class="img">
                </swiper-slide>
                <div slot="button-prev" class="swiper-button-prev" @click.prevent.stop="onChangeSlider('prev')"></div>
                <div slot="button-next" class="swiper-button-next" @click.prevent.stop="onChangeSlider('next')"></div>
              </swiper>
            </div>
            <div class="img-list-box">
              <img v-for="(item,index) in detail.image_list" :key="index" @click="curr_slider_index=index" :src="item.url" alt="" :class="['img-item',{active:index === curr_slider_index}]">
            </div>
          </div>
          <div class="right" v-if="type == 'fabric'">
            <p class="name">{{ detail.fabric_name_cn || detail.goods_no }}</p>
            <!-- <p class="no">面料编号：{{ detail.fabric_key }}</p> -->
            <div class="price-row" v-if="detail.fabric_price>0">
              <p class="price">价格:¥{{ detail.fabric_price
                }}{{ detail.unit ? "/" + detail.unit : "" }}</p>
              <span class="collect-btn" @click="toggleCollect" :title="isCollected ? '取消收藏' : '收藏'">
                <img :src="isCollected ? likedImg : likeImg" alt="" />
              </span>
            </div>
            <div class="price-row" v-else>
              <p class="price none-select" @click="onConsultService">咨询客服</p>
              <span class="collect-btn" @click="toggleCollect" :title="isCollected ? '取消收藏' : '收藏'">
                <img :src="isCollected ? likedImg : likeImg" alt="" />
              </span>
            </div>
            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            ></div>
            <div class="list">
              <div class="item">
                <span class="key">货号：</span><span class="value">{{ detail.goods_no || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">分类：</span><span class="value">{{ detail.category_name || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">成分：</span><span class="value">{{ detail.component }}</span>
              </div>
              <div class="item">
                <span class="key">克重：</span><span class="value">{{ detail.weight }}</span>
              </div>
             <div class="item">
                <span class="key">幅宽：</span><span class="value">{{ detail.width_desc }}</span>
              </div>
              <div class="item">
                <span class="key">国标：</span><span class="value">{{ detail.standard }}</span>
              </div> 
              <div class="item">
                <span class="key">织物：</span><span class="value">{{ detail.zhiwu || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">面料功能：</span><span class="value">{{ detail.gongneng || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">织法：</span><span class="value">{{ detail.zhifa || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">单位：</span><span class="value">{{ detail.unit }}</span>
              </div>
              <div class="item">
                <span class="key">提供寄样服务：</span><span class="value">{{detail.is_support_send_sample ? "是" : "否"}}</span>
              </div>
              <template v-if="matched_label_groups.length">
                <div
                  class="item"
                  v-for="(group, gIndex) in matched_label_groups"
                  :key="gIndex"
                >
                  <span class="key">{{ group.label_name }}：</span>
                  <span class="value">
                    <span
                      class="label-tag"
                      v-for="(item, iIndex) in group.items"
                      :key="iIndex"
                    >{{ item.name }}</span>
                  </span>
                </div>
              </template>
            </div>
            <div
              class="service-btn"
              v-if="detail.fabric_price > 0"
              @click="onConsultService"
            >咨询客服</div>
          </div>
          <div class="right" v-else>
            <p class="name">{{ detail.accessory_name }}</p>
            <div class="price-row">
              <p class="no">辅料编号：{{ detail.accessory_sku }}</p>
              <span class="collect-btn" @click="toggleCollect" :title="isCollected ? '取消收藏' : '收藏'">
                <img :src="isCollected ? likedImg : likeImg" alt="" />
              </span>
            </div>

            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            ></div>
            <div class="list">
              <div class="item">
                <span class="key">单位：</span
                ><span class="value">{{ detail.measure_unit }}</span>
              </div>
              <div class="item">
                <span class="key">规格：</span
                ><span class="value">{{ detail.spec }}</span>
              </div>
              <div class="item">
                <span class="key">材质：</span
                ><span class="value">{{ detail.material }}</span>
              </div>
              <template v-if="matched_label_groups.length">
                <div
                  class="item"
                  v-for="(group, gIndex) in matched_label_groups"
                  :key="gIndex"
                >
                  <span class="key">{{ group.label_name }}：</span>
                  <span class="value">
                    <span
                      class="label-tag"
                      v-for="(item, iIndex) in group.items"
                      :key="iIndex"
                    >{{ item.name }}</span>
                  </span>
                </div>
              </template>
            </div>
            <div class="action-row">
              <div class="service-btn" @click="onConsultService">咨询客服</div>
            </div>
          </div>
        </div>
        <div class="color-title">颜色分类({{ detail.color_list.length }}):</div>

        <div class="color-box">
          <div :class="['color-items',{active:detail.color_name_cn === item.color_name_cn}]" v-for="(item,index) in detail.color_list" :key="index">
            <div class="item-top">
              <span class="color-img" v-if="item.rgb" :style="{'background-color':item.rgb}"></span>
              <img v-else v-viewer @click.stop :src="item.color_value | default_img" alt="" class="color-img"/>
              <div class="color-name" :title="`${item.color_name_cn}`">{{ item.color_name_cn }}</div>
            </div>
            <div class="info-item">
              <div class="label">C卡色号:</div>
              <div class="value">{{ item.pantoneC }}</div>
            </div>
            <div class="info-item">
              <div class="label">TCX色号:</div>
              <div class="value">{{ item.pantoneTcx }}</div>
            </div>
            <div class="info-item">
              <div class="label">TPG色号:</div>
              <div class="value">{{ item.pantoneTpg }}</div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="detail.description">
        <div class="title-box">
          <div class="title">产品详情</div>
        </div>
        <div class="richtext-wrap" v-html="detail.description"></div>
      </template>
    </div>
    <Chat ref="chat"></Chat>
  </div>
</template>

<script>
import {
  AccessoryLabelList,
  FabricLabelList,
  GetAccessory,
  GetFabric,
  CollectFabric,
  CollectAccessory,
} from "@/api";
import { applyFabricSeo } from '@/seo/pageSeo';
import Chat from "@/components/Chat.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import likeImg from "@/assets/images/like.png";
import likedImg from "@/assets/images/liked.png";
export default {
  name: "Lab",
  data() {
    return {
      swiperOption: {
        loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (document.getElementById("video-material")) {
              if (this.activeIndex === 0) {
                document.getElementById("video-material").play();
              } else {
                document.getElementById("video-material").pause();
              }
            }
          },
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      detail: {
        image_list: [],
        color_list: [],
        label_ids: [],
      },
      label_list: [],
      label_group_map: {},
      id: 0,
      type: "fabric",
      curr_slider_index:0,
      isCollected: false,
      likeImg,
      likedImg,
      collectLoading: false
    };
  },
  components: {
    swiper,
    swiperSlide,
    Chat,
  },
  computed: {
    matched_label_groups() {
      const ids = this.detail.label_ids || [];
      if (!ids.length) return [];
      const result = [];
      for (const group of this.label_list) {
        const matched = group.content.filter((item) =>
          ids.includes(item.id)
        );
        if (matched.length) {
          result.push({
            label_name: group.label_name,
            items: matched,
          });
        }
      }
      return result;
    },
  },
  mounted() {
    if (this.$route.query.id) {
      const { id, type } = this.$route.query;
      this.id = id;
      this.type = type;
    } else {
      const { id, type } = this.$route.params;
      this.id = id;
      this.type = type;
    }

    this.get();
  },
  methods: {
    // 咨询客服：打开客服会话并自动发送当前面辅料图文信息
    onConsultService() {
      const detail = this.detail || {};
      const image_list = Array.isArray(detail.image_list) ? detail.image_list : [];
      const first_image = image_list[0];
      const image = (first_image && first_image.url) || "";
      const type = this.type === "accessory" ? "accessory" : "fabric";
      const name = type === "fabric"
        ? (detail.fabric_name_cn || detail.goods_no || "")
        : (detail.accessory_name || "");
      this.$refs.chat.showChatWithFabricAccessory({
        type,
        id: detail.id || 0,
        name,
        image,
      });
    },
    // 收藏 / 取消收藏切换（共用接口，is_collect=1 收藏，0 取消）
    async toggleCollect() {
      const id = this.detail.id;
      if (!id || this.collectLoading) return;
      const isCollect = this.isCollected ? 0 : 1;
      this.collectLoading = true;
      try {
        const api = this.type === "accessory" ? CollectAccessory : CollectFabric;
        const res = await api({ id, is_collect: isCollect });
        this.$Message.success(isCollect === 1 ? "收藏成功" : "已取消收藏");
        // 优先以接口返回的收藏态为准，未返回则本地翻转
        const payload = (res && res.data) || {};
        this.isCollected =
          typeof payload.is_collect !== "undefined"
            ? !!payload.is_collect
            : !this.isCollected;
      } catch (e) {
        // 未登录等场景：请求拦截器会跳转登录页，这里仅做兜底提示
        if (!e || !e.toLogin) {
          this.$Message.error((e && e.msg) || "操作失败");
        }
      } finally {
        this.collectLoading = false;
      }
    },
    onChangeSlider(type){
      console.log('type---->',type);
      const {curr_slider_index} = this;
      if(curr_slider_index === 0 && type === 'prev'){
        this.curr_slider_index = this.detail.image_list.length - 1;
        return;
      }
      if(curr_slider_index === this.detail.image_list.length - 1 && type === 'next'){
        this.curr_slider_index = 0;
        return;
      }
      this.curr_slider_index = type == "prev" ? curr_slider_index - 1 : curr_slider_index + 1;
    },
    async get() {
      if (this.type == "fabric") {
        var { data } = await GetFabric({
          id: this.id,
        });
      } else {
        var { data } = await GetAccessory({
          id: this.id,
        });
      }
      this.detail = data;
      // 详情接口已返回 is_collect（未登录为 0，已登录按实际收藏态）
      this.isCollected = !!data.is_collect;
      console.log('this.detail:', this.detail);
      applyFabricSeo(this.detail);
      let labelRes;
      if (this.type == "fabric") {
        labelRes = await FabricLabelList();
      } else {
        labelRes = await AccessoryLabelList();
      }
      this.label_list = labelRes.data || [];
      this.label_group_map = this.buildLabelMap(this.label_list);
    },
    buildLabelMap(list) {
      const map = {};
      for (const group of list) {
        for (const item of group.content) {
          map[item.id] = {
            id: item.id,
            name: item.name,
            label_name: group.label_name,
          };
        }
      }
      return map;
    },
  },
};
</script>

<style lang="scss" scoped>
.fabric-content-box {
  background: #f8f6f9;
}
.fabric-content-wrap {
  width: 1200px;
  margin: 0px auto;
  top: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    background: #ffffff;
    border-radius: 5px;
    margin-top: 10px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 30px 40px;
      height: auto;
    }
  }

  .info-wrap {
    background: #ffffff;
    border-radius: 5px;
    padding: 30px;
    margin-bottom: 100px;
    .left-popup {
      width: 500px;
      .f-img {
        width: 500px;
        height: 500px;
      }
    }

    .right {
      flex: 1;
      padding-right: 20px;
      padding-left: 20px;
      .name {
        color: #1a1a1a;
        font-size: 20px;
      }
      .no {
        color: #808080;
        font-size: 14px;
        margin-bottom: 20px;
        margin: 10px 0;
        display:flex;
        align-items:center;
        column-gap:15px;
      }
      .price {
        color: #e00000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 17px;
        width:fit-content;
        cursor:pointer;
        &.none-select{
          user-select:none;
        }
      }
      .service-btn {
        display: inline-block;
        color: #ff5967;
        font-size: 14px;
        padding: 5px 10px;
        border: 1px solid #ff5967;
        border-radius: 8px;
        cursor: pointer;
        margin-top: 10px;
      }
      // 价格 / 咨询客服 行：最右侧收藏图标
      .price-row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .price {
          margin: 0;
          padding-bottom: 0;
        }
      }
      .action-row {
        display: flex;
        align-items: center;
        column-gap: 16px;
        margin-top: 10px;
        width: 100%;
        justify-content: space-between;
      }
      .collect-btn {
        margin-right: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
        transition: transform 0.15s ease;
        img {
          width: 18px;
          height: 18px;
          display: block;
        }
        &:hover {
          transform: scale(1.1);
        }
        &:active {
          transform: scale(0.92);
        }
      }
      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          // width: 80px;
        }

        .value {
          color: #1a1a1a;
        }

        .label-tag {
          color: #1a1a1a;
          font-size: 13px;
          margin-right: 8px;
        }
      }
    }
    .color-title {
      color: #1a1a1a;
      font-size: 16px;
      font-weight: bold;
      margin-top: 40px;
    }
    .color-box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-top: 26px;
      .color-items{
        user-select:none;
        width:180px;
        border:1px solid #e3e3e3;
        border-radius:4px;
        padding:8px;
        display:flex;
        flex-direction:column;
        row-gap:4px;
        &.active{
          border:1px solid #ff5967;
        }
        .item-top{
          display:flex;
          align-items:center;
          column-gap: 8px;
          .color-img{
            width:30px;
            height:30px;
            border:1px solid #e3e3e3;
            border-radius:4px;
          }
          .color-name{
            font-size:12px;
            color:#333;
            font-weight:500;
          }
        }
        .info-item{
          display:flex;
          align-items:center;
          column-gap:5px;
          .label{
            color:#999;
            font-size:12px;
            flex-shrink:0;
          }
          .value{
            color:#666;
            font-size:12px;
            white-space:pre-wrap;
            word-break:break-all;
          }
        }
      }
    }
  }

  .richtext-wrap {
    flex: 1;
    padding-bottom: 60px;
    background: #fff;
    margin-bottom: 100px;
    padding: 0 8.75%;
  }
}

.slider {
  width: 500px;
  height: 500px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  .swiper-slide {
    width: 500px;
    height: 500px;
  }

  .img,
  video {
    width: 500px;
    height: 500px;
    object-fit: contain;
  }
}

.img-list-box{
  display:flex;
  align-items:center;
  width:100%;
  flex-wrap:wrap;
  gap:10px;
  margin-top:10px;
  .img-item{
    width:60px;
    height:60px;
    border:2px solid #e0e0e0;
    border-radius:10px;
    cursor:pointer;
    &.active,&:hover{
      border:2px solid #fa3d5a;
    }
  }
}

::v-deep .viewer-container {
  z-index: 999999 !important;
}
</style>
